"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPointsToMM = void 0;
var DOTS_PER_INCH = 72;
var MM_PER_INCH = 25.4;
var convertPointsToMM = function (points) {
    return (points / DOTS_PER_INCH) * MM_PER_INCH;
};
exports.convertPointsToMM = convertPointsToMM;
